/**
 * 节点类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 节点类型
 */
enum GSPCommonObjectType {
    /**
     * 主节点
     */
    MainObject,

    /**
     * 非主节点
     */
    ChildObject,
}

export { GSPCommonObjectType };

